import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import {
  getAgentBonusHeader,
  getAgentRebateLevel,
  getAgentWinLoss,
  getComissionOverview,
  getDepositRebateRate,
  getLevelBonus,
  getNetLossLevelProgress,
  getPlatformFee,
  getPromotionFee,
} from "../service";

export const useGetAgentBonusHeader = ({ params, options }) => {
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.COMISSION_HEADER, ..._arrParams],
    () => getAgentBonusHeader({ params }).then((res) => res.data),
    {
      ...options,
    },
  );
};

export const useGetAgentWinLoss = ({ params, agent_bonus_id, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.COMISSION_WIN_LOSS, agent_bonus_id, ..._arrParams],
    ({ pageParam = 1 }) =>
      getAgentWinLoss({ params, agent_bonus_id, page: pageParam }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

export const useGetPlatformFee = ({ params, agent_bonus_id, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.COMISSION_PLATFORM_FEE, agent_bonus_id, ..._arrParams],
    ({ pageParam = 1 }) =>
      getPlatformFee({ params, agent_bonus_id, page: pageParam }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

export const useGetPromotionFee = ({ params, agent_bonus_id, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.COMISSION_PROMO_FEE, agent_bonus_id, ..._arrParams],
    ({ pageParam = 1 }) =>
      getPromotionFee({ params, agent_bonus_id, page: pageParam }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

export const useGetLevelBonus = ({ params, agent_bonus_id, level, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.COMISSION_LEVEL, agent_bonus_id, level, ..._arrParams],
    ({ pageParam = 1 }) =>
      getLevelBonus({
        params,
        agent_bonus_id,
        level: level,
        page: pageParam,
      }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

export const useGetComissionOverview = ({ options }) => {
  return useQuery(
    [queryKey.COMISSION_OVERVIEW],
    () =>
      getComissionOverview().then((res) => {
        res.data.data.agent_bonus.reverse();
        return res.data.data;
      }),
    { ...options },
  );
};

export const useGetAgentRebateLevel = ({ options }) => {
  return useQuery(
    [queryKey.AGENT_REBATE_LEVEL],
    () =>
      getAgentRebateLevel().then((res) => {
        return res.data.data;
      }),
    { ...options },
  );
};

export const useGetDepositReabateRate = ({ options }) => {
  return useQuery(
    [queryKey.DEPOSIT_REBATE_RATE],
    () =>
      getDepositRebateRate().then((res) => {
        console.debug("res", res);
        return res.data.data;
      }),
    { ...options },
  );
};

export const useGetNetLossLevelProgress = ({ options }) => {
  return useQuery(
    [queryKey.NET_LOSS_PROGRESS],
    () =>
      getNetLossLevelProgress().then((res) => {
        return { ...res.data.data };
      }),
    { ...options },
  );
};
